<template>
    <b-modal
        b-errorModal
        id="errorModal"
        hide-header-close
        ok-only
        title="Ocorreu um erro"
    >
        <div class="container-fluid m-0 p-0">
            <p>
                {{ text }}
            </p>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'ErrorModal',
    methods: {
        toggleModal() {
            this.$bvModal.toggle(errorModal);
        }
    },
    props: {
        text: {
            type: String,
            required: true
        }
    }
}
</script>

<style>
    #errorModal .modal-dialog {
        top: 50%;
        transform: translateY(-50%);
    }
</style>



// WEBPACK FOOTER //
// src/components/molecules/ErrorModal.vue